import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { hideModal } from 'actions/common'
import { promoCodeSetEditingPromoCode, promoCodeEdit } from 'actions/promo-code'
import Modal from 'components/modal'
import { PROMO_CODE_MODAL } from 'constants/modal-constants'
import { getCurrentModal } from 'selectors/common'
import { getCurrentEditingPromoCodeId } from 'selectors/promo-code'
import { getPromoCode } from 'selectors/entities'

import PromoCodeFormModal from './promo-code-form-modal'

class PromoCodeFormModalContainer extends Component {

  constructor(props) {
    super(props)

    this.onCancelClick = this.onCancelClick.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onCancelClick() {
    this.props.promoCodeSetEditingPromoCode(null)
    this.props.hideModal()
  }

  onSubmit(values) {
    this.props.promoCodeSetEditingPromoCode(null)
    this.props.promoCodeEdit(this.props.currentEditingPromoCodeId, values)
    this.props.hideModal()
  }

  render() {
    const isOpen = this.props.currentEditingPromoCodeId && this.props.currentModal === PROMO_CODE_MODAL
    return (
      <Modal light wide closeModal={this.props.hideModal} isOpen={isOpen}>
        <PromoCodeFormModal
          {...this.props}
          onCancelClick={this.onCancelClick}
          onSubmit={this.onSubmit}
          initialValues={this.props.initialValues}
        />
      </Modal>
    )
  }

}

PromoCodeFormModalContainer.propTypes = {
  currentModal: PropTypes.string,
  promoCodeSetEditingPromoCode: PropTypes.func,
  hideModal: PropTypes.func,
  currentEditingPromoCodeId: PropTypes.any,
  promoCodeEdit: PropTypes.func,
  initialValues: PropTypes.object,
}

const mapStateToProps = state => {
  const currentEditingPromoCodeId = getCurrentEditingPromoCodeId(state)
  return {
    currentEditingPromoCodeId,
    currentModal: getCurrentModal(state),
    initialValues: getPromoCode(currentEditingPromoCodeId)(state),
  }
}

const mapDispatchToProps = { hideModal, promoCodeSetEditingPromoCode, promoCodeEdit }

export default connect(mapStateToProps, mapDispatchToProps)(PromoCodeFormModalContainer)



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-form-modal/promo-code-form-modal-container.js
 **/